import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import WhatsAppFloat from "@/components/WhatsAppFloat";
import { getBlogs } from "@/lib/api";
import { Calendar, ArrowRight } from "lucide-react";
import useSEO from "@/hooks/useSEO";
import { SITE_SEO } from "@/constants/seo";
import { IONA } from "@/constants/site";

export default function BlogListPage() {
  useSEO({
    title: SITE_SEO.blogList.title,
    description: SITE_SEO.blogList.description,
    canonical: IONA.siteUrl + "/blog",
  });
  const [blogs, setBlogs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getBlogs()
      .then(setBlogs)
      .catch(() => setBlogs([]))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div data-testid="blog-list-page" className="min-h-screen bg-white">
      <Navbar />
      <main className="pt-32 pb-20">
        <div className="iona-container">
          <div className="max-w-2xl mb-14">
            <div className="text-xs uppercase tracking-[0.3em] text-[#5E2A84] mb-4">
              — İONA Blog
            </div>
            <h1 className="font-serif text-4xl sm:text-5xl lg:text-6xl text-[#1A1A1A] leading-[1.05] tracking-tight mb-6">
              Güzellik & bakım <span className="italic text-[#5E2A84]">rehberi</span>
            </h1>
            <p className="text-[#4A4A4A] text-base lg:text-lg leading-relaxed">
              Lazer epilasyon, cilt bakımı, saten yüz germe ve daha fazlası
              hakkında uzman içeriklerimiz.
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
            {loading ? (
              [...Array(6)].map((_, i) => (
                <div
                  key={i}
                  className="h-96 bg-[#F8F9FA] rounded-3xl animate-pulse border border-[#F0F0F0]"
                />
              ))
            ) : blogs.length === 0 ? (
              <div className="col-span-full text-center py-20 text-[#4A4A4A]">
                Henüz blog yazısı bulunmuyor.
              </div>
            ) : (
              blogs.map((b) => (
                <Link
                  key={b.id}
                  to={`/blog/${b.slug}`}
                  data-testid={`blog-card-${b.slug}`}
                  className="group bg-white rounded-3xl overflow-hidden border border-[#F0F0F0] iona-hover-lift block"
                >
                  <div className="h-56 overflow-hidden bg-[#F4F1F9]">
                    {b.cover_image && (
                      <img
                        src={b.cover_image}
                        alt={b.title}
                        className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
                      />
                    )}
                  </div>
                  <div className="p-7">
                    <div className="flex items-center gap-3 text-xs text-[#4A4A4A] mb-4">
                      <span className="px-3 py-1 rounded-full bg-[#F4F1F9] text-[#5E2A84] uppercase tracking-wider">
                        {b.category}
                      </span>
                      <span className="flex items-center gap-1.5">
                        <Calendar className="w-3 h-3" />
                        {new Date(b.created_at).toLocaleDateString("tr-TR")}
                      </span>
                    </div>
                    <h3 className="font-serif text-xl text-[#1A1A1A] mb-3 leading-snug group-hover:text-[#5E2A84] transition-colors line-clamp-2">
                      {b.title}
                    </h3>
                    <p className="text-sm text-[#4A4A4A] leading-relaxed line-clamp-3 mb-5">
                      {b.excerpt}
                    </p>
                    <div className="inline-flex items-center gap-2 text-[#5E2A84] text-sm font-medium group-hover:gap-3 transition-all">
                      Devamını Oku
                      <ArrowRight className="w-4 h-4" />
                    </div>
                  </div>
                </Link>
              ))
            )}
          </div>
        </div>
      </main>
      <Footer />
      <WhatsAppFloat />
    </div>
  );
}
